import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const setDisplayPreviewTemplateThemeTrayReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean | null>) => {
    if (action.payload === null) {
      state.displayPreviewTemplateThemeTray = !state.displayPreviewTemplateThemeTray;
    } else {
      state.displayPreviewTemplateThemeTray = action.payload;
    }
  });
};

export default setDisplayPreviewTemplateThemeTrayReducer;
